import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import StatsBar from './components/StatsBar';
import Footer from './components/Footer';
import Bob from './components/Bob';
import HomePage from './pages/HomePage';
import ServicesPage from './pages/ServicesPage';
import AICareersPage from './pages/AICareersPage';
import JobsPage from './pages/JobsPage';
import ContactPage from './pages/ContactPage';
import ApplyPage from './pages/ApplyPage';
import AdminPage from './pages/AdminPage';
import './App.css';

const getRouteInfo = () => {
  const pathname = window.location.pathname.replace(/^\/+|\/+$/g, '').trim();
  const queryString = window.location.search.replace(/^\?/, '');

  return {
    route: pathname || 'home',
    params: Object.fromEntries(new URLSearchParams(queryString)),
  };
};

function App() {
  const [routeInfo, setRouteInfo] = useState(getRouteInfo());

  useEffect(() => {
    const handleLocationChange = () => {
      setRouteInfo(getRouteInfo());
      window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const handleInternalLinkClick = (event) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      const link = event.target.closest('a[href]');
      if (!link || link.target || link.hasAttribute('download')) {
        return;
      }

      const nextUrl = new URL(link.href, window.location.origin);
      const isCurrentPage = nextUrl.pathname === window.location.pathname && nextUrl.search === window.location.search;
      if (nextUrl.origin !== window.location.origin || isCurrentPage) {
        return;
      }

      event.preventDefault();
      window.history.pushState({}, '', `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`);
      handleLocationChange();
    };

    document.addEventListener('click', handleInternalLinkClick);
    window.addEventListener('popstate', handleLocationChange);
    return () => {
      document.removeEventListener('click', handleInternalLinkClick);
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);

  const renderPage = () => {
    switch (routeInfo.route) {
      case 'services':
        return <ServicesPage selectedService={routeInfo.params.service || ''} />;
      case 'ai-careers':
        return <AICareersPage />;
      case 'jobs':
        return <JobsPage selectedTrack={routeInfo.params.track || ''} selectedJob={routeInfo.params.job || ''} />;
      case 'contact':
        return <ContactPage />;
      case 'apply':
        return <ApplyPage selectedService={routeInfo.params.service || ''} />;
      case 'admin':
        return <AdminPage />;
      case 'home':
      default:
        return <HomePage />;
    }
  };

  return (
    <div className="app-shell">
      {routeInfo.route !== 'admin' ? <Navbar currentRoute={routeInfo.route} /> : null}
      <main className="app-main">{renderPage()}</main>
      {routeInfo.route !== 'admin' ? (
        <>
          <StatsBar />
          <Footer />
        </>
      ) : null}
      <Bob />
    </div>
  );
}

export default App;
